import React from 'react';
import RecentEvents from './RecentEvents';
import './RecentEvents.css';




export default function EventsPage() {
    return (
        <div>
             <RecentEvents />
        </div>
    )
}
